var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangePin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162.4 249",
    style: {
      enableBackground: "new 0 0 162.4 249"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FE9D68;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.4,80.7C162.4,36.1,126.3,0,81.7,0S1,36.1,1,80.7c0,13.7,3.4,26.6,9.4,37.9l0,0l0.2,0.3 c0.1,0.2,0.3,0.5,0.4,0.7L81.7,249l70.8-129.4c0.1-0.2,0.3-0.5,0.4-0.7l0.2-0.3l0,0C159,107.3,162.4,94.4,162.4,80.7z M81.7,117 c-20,0-36.2-16.2-36.2-36.2c0-20,16.2-36.2,36.2-36.2c20,0,36.2,16.2,36.2,36.2C117.9,100.8,101.7,117,81.7,117z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePin);
export default __webpack_public_path__ + "static/media/orangePin.4f4e20521b1742ce8c7715adaaa3b749.svg";
export { ForwardRef as ReactComponent };